module.exports = "/fast-coin/img/coin/anim/in/coin_in_019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_019.png
// module id = 2289
// module chunks = 5